import React from "react";
import { Outlet, Link, useLocation, matchPath, useNavigate } from "react-router-dom";
import { Box, Tabs, Tab, Container, Select, MenuItem } from "@mui/material";

const tabs = [
  { path: "", label: "Dashboard" },
  { path: "organizations", label: "Organizations" },
  { path: "users", label: "Users" },
  { path: "events", label: "Events" },
  { path: "orders", label: "Orders" },
  { path: "payments", label: "Payments" },
  { path: "maintenance", label: "Maintenance" },
];

export default function CRM() {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;

  const routes = tabs.map((tab) => tab.path);
  const currentRoute = routes.find((route) => {
    if (route === "") {
      return matchPath({ path: "/crm", end: true }, pathname);
    }
    return matchPath({ path: `/crm/${route}`, end: false }, pathname);
  });

  // Handle undefined vs empty string - empty string is valid for dashboard
  const tabsValue = currentRoute !== undefined ? currentRoute : false;

  const handleSelectChange = (event) => {
    const path = event.target.value;
    navigate(path === "" ? "/crm" : `/crm/${path}`);
  };

  return (
    <Box>
      <Container>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "primary.light",
            marginTop: 2,
          }}
        >
          <Select
            value={currentRoute ?? ""}
            onChange={handleSelectChange}
            sx={{
              marginLeft: "5px",
              marginRight: "5px",
              marginBottom: "5px",
              display: { xs: "block", sm: "block", md: "none" },
            }}
          >
            {tabs.map(({ path, label }) => (
              <MenuItem
                key={path}
                value={path}
                component={Link}
                to={path === "" ? "/crm" : `/crm/${path}`}
              >
                {label}
              </MenuItem>
            ))}
          </Select>
          <Tabs
            value={tabsValue}
            aria-label="CRM navigation"
            sx={{
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            {tabs.map(({ path, label }) => (
              <Tab
                key={path}
                label={label}
                component={Link}
                to={path === "" ? "/crm" : `/crm/${path}`}
                value={path}
              />
            ))}
          </Tabs>
        </Box>
        <Outlet />
      </Container>
    </Box>
  );
}
